'use strict';

var React = require('react');
var Button = require('./Button-7698424c.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ButtonDismiss({ onClick, ariaLabel }) {
    return (React__default["default"].createElement(Button.Button, { ariaLabel: ariaLabel, icon: "remove", onClick: onClick, type: "tertiary", variation: "subtle" }));
}

exports.ButtonDismiss = ButtonDismiss;
